import { Card } from 'react-bootstrap';
import { BsAlarm, BsHeadset, BsTelephoneForward, BsWhatsapp } from 'react-icons/bs';
import { Link } from '@/compat/react-router-dom';

const Help = () => {
  return (
    <Card className="card-body bg-light p-4">
      <h4 className="card-title">Need Help?</h4>
      <ul className="list-group list-group-borderless">
        <li className="list-group-item py-3">
          <a href="https://wa.me/306906241516" target="_blank" rel="noreferrer" className="h6 mb-0">
            <BsWhatsapp className="fa-fw text-primary fs-5 me-2" />
            <span className="fw-light me-1">What's app:</span>+30 690 6241516
          </a>
        </li>
        <li className="list-group-item py-0">
          <hr className="my-0" />
        </li>
        <li className="list-group-item py-3">
          <a href="tel:+302842022892" className="h6 mb-0">
            <BsTelephoneForward className="fa-fw text-primary fs-5 me-2" />
            <span className="fw-light me-1">Call us on:</span>+30 28420 22892
          </a>
        </li>
        <li className="list-group-item py-0">
          <hr className="my-0" />
        </li>
        <li className="list-group-item py-3">
          <h6 className="mb-0">
            <BsAlarm className="fa-fw text-primary fs-5 me-2" />
            <span className="h6 fw-light me-1 mb-0">Timing:</span>9am to 8pm
          </h6>
        </li>
        <li className="list-group-item py-0">
          <hr className="my-0" />
        </li>
        <li className="list-group-item py-3">
          <Link to="/contact" className="h6 mb-0">
            <BsHeadset className="fa-fw text-primary fs-5 me-2" />
            Let Us Call You
          </Link>
        </li>
      </ul>
    </Card>
  );
};

export default Help;

